import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import xmlAlertFormatter, { getAlertAttributes } from "@ext/markdown/elements/alert/edit/logic/xml/alertFormatter";

const UNSAFE_LEGACY_ATTR = /[:\]\\\n]/;

/**
 * Attributes are positional: keep an empty type when a title follows, or the title is read as the type.
 * Trim only trailing colons, as `LegacyFormatter.openTag` does. The legacy tag has no escaping, so values it cannot hold go out as xml.
 */
const alertFormatter: NodeSerializerSpec = async (state, node, parent, index) => {
	const { type, title } = getAlertAttributes(node.attrs);
	if (UNSAFE_LEGACY_ATTR.test(type) || UNSAFE_LEGACY_ATTR.test(title))
		return xmlAlertFormatter(state, node, parent, index);
	const head = `:${type}:${title}`.replace(/:+$/, "");
	state.write(`[alert${head}]\n\n`);
	await state.renderContent(node);
	state.write("[/alert]");
	state.closeBlock(node);
};

export default alertFormatter;
